(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["C-CustomIconBar"] && !Shopify.designMode) return;
  try {
    
// Custom JavaScript here

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nz-transparency-landing-perf"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.nz-video-embed__play');
    if (!button) return;

    var wrapper = button.closest('.nz-video-embed');
    if (!wrapper) return;

    var type = wrapper.getAttribute('data-video-type');
    var id   = wrapper.getAttribute('data-video-id');
    var mp4  = wrapper.getAttribute('data-video-mp4');

    // If an MP4 URL is provided, use that first
    if (mp4) {
      var video = document.createElement('video');
      video.setAttribute('src', mp4);
      video.setAttribute('playsinline', '');
      video.setAttribute('controls', 'controls');
      video.setAttribute('autoplay', 'autoplay');
      video.setAttribute('muted', 'muted'); // helps autoplay on mobile
      video.style.width = '100%';
      video.style.height = '100%';

      wrapper.innerHTML = '';
      wrapper.appendChild(video);
      return;
    }

    // Fallback: YouTube / Vimeo embed
    if (!id) return;

    var src;
    if (type === 'vimeo') {
      src = 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1';
    } else {
      src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1';
    }

    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', src);
    iframe.setAttribute('title', 'Nature\'s Zest Explainer Video');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    iframe.setAttribute('allowfullscreen', 'true');

    wrapper.innerHTML = '';
    wrapper.appendChild(iframe);
  });

  } catch(e) { console.error(e); }
})();
})();
